export default {
  SET_username(state, payload) {
    state.username = payload;
  },
};
